/**
 * @author WYX
 * @date 2019/12/26
 * @Description: 新渠道视频稿件底部按钮
 */
angular.module('editPageVideoFooterModule', []).directive('editPageVideoFooter', [
    '$q',
    '$state',
    '$timeout',
    '$validation',
    'modalDialog',
    'newMediaService',
    'trsspliceString',
    'ueditorService',
    'trsHttpService',
    'messagePublishService',
    'editingCenterService',
    'storageListenerService',
    'jsonArrayToStringService',
    'editCenUploadVideoForXjService',
    'localStorageService',
    'editIsLock',
    'beforeonload',
    '$window',
    'toutConst',
    function (
        $q,
        $state,
        $timeout,
        $validation,
        modalDialog,
        newMediaService,
        trsspliceString,
        ueditorService,
        trsHttpService,
        messagePublishService,
        editingCenterService,
        storageListenerService,
        jsonArrayToStringService,
        editCenUploadVideoForXjService,
        localStorageService,
        editIsLock,
        beforeonload,
        $window,
        toutConst
    ) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageVideoFooter/editPageVideoFooter.html',
            replace: true,
            link: function ($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    $scope.footFunc.forEach((item) => {
                        messagePublishService.subscribe(
                            `${$scope.parentStatus.mediaName}${item}`,
                            function () {
                                $scope[item]();
                            },
                            $scope
                        );
                    });
                    emitCloseWindow();
                }

                /**
                 * [handleBtnClick description]动态执行scope方法
                 *
                 * @param   {[type]}  funname  [funname description]
                 *
                 * @return  {[type]}           [return description]
                 */
                $scope.handleBtnClick = function (funname) {
                    eval('$scope.' + funname + '()');
                };

                /**
                 * [toggleEditor description]是否收起正文
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.toggleEditor = function () {
                    $scope.parentStatus.zhengwen = !$scope.parentStatus.zhengwen;
                    if ($scope.parentStatus.zhengwen) {
                        // 隐藏编辑器
                        $('.body_manuscript_content').addClass('editorHidden');
                    } else {
                        $('.body_manuscript_content').removeClass('editorHidden');
                    }
                };

                /**
                 * [saveList description]切换时保存list数据
                 *
                 * @param   {[type]}  flag  [flag description] 判断是否进行加锁操作，如果关闭页面则不加锁，不关闭则加锁
                 *
                 * @return  {[type]}        [return description]
                 */
                function saveList(flag) {
                    var defer = $q.defer();
                    if (!$scope.parentStatus.isFusionEditor) {
                        ueditorService.saveContent($scope.list);
                    }
                    $scope[$scope.parentData.formName].$pending = {};
                    $validation
                        .validate($scope[$scope.parentData.formName])
                        .success(function () {
                            modalDialog.isSecretInformation(
                                true,
                                function () {
                                    var list = angular.copy($scope.list);
                                    list.ARTICLECLASSIFICATION = $scope.parentData.articleClass.ARTICLECLASSIFICATIONID;
                                    list.LABEL = trsspliceString.spliceString(angular.copy($scope.parentData.LABEL), 'name', ',');
                                    list.ORIGINALTYPE = $scope.parentData.originType;
                                    list.SPECIALDOC = $scope.parentData.specialDoc;
                                    list.ARTICLEID = $scope.parentStatus.articleid || '0';
                                    list = jsonArrayToStringService.jsonArrayToString(list);
                                    $scope[$scope.parentData.formName].$setPristine();
                                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                        function (data) {
                                            $scope.afterSaveList && $scope.afterSaveList(data); // 给各个渠道留一个钩子，用来在保存成功后处理一些个性化的内容
                                            $scope.list.METADATAID = $state.params.articleid = $scope.list.articleid = data.METADATAID.replace(
                                                /\"/g,
                                                ''
                                            ); // 后台返回的是字符串，需要转成数字类型
                                            beforeonload.refresh($scope.$parent);
                                            //  稿件加锁
                                            if (flag) {
                                                editIsLock.lockDraft($state.params.articleid);
                                            }
                                            editCenUploadVideoForXjService.clearDraftVideoInfo($scope.parentStatus.mediaName, 'articleid'); // 未确认
                                            defer.resolve();
                                        },
                                        function () {
                                            if ($scope.parentStatus.isFusionEditor) {
                                                messagePublishService.publish(`${$scope.parentStatus.mediaName}saveOver`, false); // 融合编辑器防止请求卡死
                                            }
                                        }
                                    );
                                },
                                function () {
                                    defer.reject();
                                }
                            );
                        })
                        .error(function () {
                            editingCenterService.checkSaveError($scope[$scope.parentData.formName], $scope.element, $scope); // 定位输入错的表单位置
                            defer.reject();
                        });
                    return defer.promise;
                }

                /* 稿件操作开始*/
                /**
                 * [save description] 保存稿件
                 * @param {[type]} [flag] [description] 是否为操作前的保存
                 * @return {[type]} [description]
                 */
                $scope.save = function () {
                    var defer = $q.defer();
                    editCenUploadVideoForXjService.exampleVideoBeforeSave($scope).then(() => {
                        saveList(true).then(
                            function (data) {
                                storageListenerService[$scope.parentStatus.ListListener]('save');
                                $scope.status.isEditDraft = true;
                                $state.transitionTo($state.current, $state.params, {
                                    reload: false,
                                });
                                if (!$scope.parentStatus.isFusionEditor) {
                                    $timeout(function () {
                                        modalDialog.saveModel('保存成功', '', 'success');
                                    }, 500);
                                }
                                messagePublishService.publish(`${$scope.parentStatus.mediaName}saveOver`, true);
                                // 保存
                                messagePublishService.publish(`${$scope.parentStatus.mediaName}VersionInit`);
                                defer.resolve();
                            },
                            function (msg) {
                                if (!$scope.parentStatus.isFusionEditor) {
                                    modalDialog.alertType('保存失败', '', 'warning', false);
                                }
                                messagePublishService.publish(`${$scope.parentStatus.mediaName}saveOver`, false);
                                defer.reject(msg);
                            }
                        );
                    }, () => {
                        defer.reject({
                            plat: '头条号'
                        });
                    });
                    return defer.promise;
                };

                /**
                 * [Trial description]送审操作
                 * @return {[type]} [description]
                 */
                $scope.Trial = function () {
                    newMediaService.trial($scope, toutConst.trial).then((opinion) => {
                        saveList().then(function () {
                            let toutiaoParams = angular.extend({
                                METADATAIDS: $state.params.articleid,
                                CHANNELID: $state.params.account,
                                opinion: opinion,
                            }, toutConst.trial);
                            messagePublishService.publish('doEditPageOperation', toutiaoParams);
                        });
                    });

                    // saveList().then(function (data) {
                    //     $scope.loadingPromise = newMediaService.trial(
                    //         angular.extend($scope.httpUrl.baseParam, $scope.parentStatus.typeConst.trial),
                    //         $scope.parentStatus.mediaName
                    //     );
                    // });
                    
                };

                /**
                 * [revise description]修订操作
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.revise = function () {
                    modalDialog.confirmModal('修订', '确认修订?', function () {
                        saveList().then(function (data) {
                            var params = {
                                MediaType: $scope.parentStatus.mediaType,
                            };
                            $scope.loadingPromise = editingCenterService.reviseFinished(params);
                        });
                    });
                };

                /**
                 * [Kill description]撤稿操作
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.Kill = function () {
                    newMediaService.rejection($scope, toutConst.kill).then((opinion) => {
                        saveList().then(function () {
                            let toutParams = angular.extend(
                                {
                                    ChnlDocIds: $scope.list.RECID,
                                    CHANNELID: $state.params.account,
                                    opinion: opinion,
                                },
                                toutConst.kill
                            );
                            messagePublishService.publish('doEditPageOperation', toutParams);
                        });
                    });

                    // saveList().then(function () {
                    //     modalDialog.inputModel('撤稿', '撤稿原因（可选）', function (content) {
                    //         $scope.loadingPromise = trsHttpService
                    //             .httpServer(
                    //                 trsHttpService.getWCMRootUrl(),
                    //                 angular.extend($scope.httpUrl.baseParam, $scope.parentStatus.typeConst.kill, { ChnlDocIds: $scope.list.RECID }),
                    //                 'get'
                    //             )
                    //             .then(
                    //                 function (data) {
                    //                     modalDialog.alertType('撤稿成功', '', 'success', false, function () { });
                    //                     storageListenerService[$scope.parentStatus.ListListener]('trial');
                    //                     $timeout(function () {
                    //                         window.close();
                    //                     }, 2000);
                    //                 },
                    //                 function (data) {
                    //                     modalDialog.alertType('撤稿失败', data.message, 'error', 'confirm');
                    //                 }
                    //             );
                    //     });
                    // });
                };

                /**
                 * [Sign description]签发操作
                 * @return {[type]} [description]
                 */
                $scope.Sign = function () {
                    $scope.loadingPromise = newMediaService.sign($scope).then(() => {
                        saveList().then(() => {
                            let signParams = angular.extend({
                                METADATAIDS: $state.params.articleid,
                                CHANNELID: $state.params.account,
                            }, $state.params.platform === '1' ? toutConst.signOfDaishen : toutConst.signOfDaibian);
                            messagePublishService.publish('doEditPageOperation', signParams);
                        });
                    });

                    // saveList().then(function (data) {
                    //     $scope.loadingPromise = newMediaService.sign(
                    //         angular.extend($scope.httpUrl.baseParam, $scope.parentStatus.typeConst.sign),
                    //         $scope.parentStatus.mediaName
                    //     );
                    // });
                };

                // /**
                //  * [showVersion description] 判断是融合编辑下的获取版本记录还是渠道内的获取版本记录
                //  * @return  {[type]}  [return description]
                //  */
                // function showVersion() {
                //     if ($scope.status.isFusionEditor) {
                //         getFusionVersion();
                //     } else {
                //         getVersion();
                //         getPropagandaReview();
                //     }
                // }

                /**
                 * [closeCurrView description] 页面关闭
                 * @return  {[type]}  [return description]
                 */
                $scope.closeCurrView = function () {
                    var isChangeContent = false;
                    if (window.UE) {
                        isChangeContent = ueditorService.contentTranscoding($scope.list) !== ueditorService.bindContent();
                    }
                    editingCenterService
                        .closeWinow($scope[$scope.parentData.formName].$dirty, isChangeContent)
                        .then(
                            function () {
                                saveList().then(function () {
                                    storageListenerService[$scope.parentStatus.ListListener]('save');
                                    editIsLock.normalLock($scope.parentStatus.articleid).then(function (data) {
                                        $window.close();
                                    });
                                });
                            },
                            function () {
                                angular.isDefined($scope.parentStatus.articleid)
                                    ? editIsLock.normalLock($scope.parentStatus.articleid).then(function (data) {
                                        $window.close();
                                    })
                                    : $window.close();
                            }
                        );
                };

                /**
                 * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
                 * @return {[type]} [description]
                 */
                function emitCloseWindow() {
                    // window.onbeforeunload = function() {
                    //     if ($scope.parentStatus.articleid) {
                    //         localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $scope.parentStatus.articleid }));
                    //     }
                    // };
                    editingCenterService.allAppCloseWindow($scope, { typeName: 'article', saveLocal: false });
                }
            },
        };
    },
]);
